import { http } from "./http";

export const authApi = {
  register: (payload) => http.post("/auth/register", payload),
  login: (payload) => http.post("/auth/login", payload),
  logout: () => http.post("/auth/logout"),
  requestPasswordReset: (payload) => http.post("/auth/forgot-password/request", payload),
  verifyPasswordResetToken: (payload) => http.post("/auth/forgot-password/verify", payload),
  resetPassword: (payload) => http.post("/auth/forgot-password/reset", payload),
  me: () => http.get("/auth/me"),
};

export const tracksApi = {
  list: () => http.get("/tracks"),
  enroll: (trackId) => http.post(`/tracks/${trackId}/enroll`),
  unenroll: (trackId) => http.delete(`/tracks/${trackId}/enroll`),
  enrollmentStatus: (trackId) => http.get(`/tracks/${trackId}/enrollment-status`),
  requests: (trackId) => http.get(`/instructor/tracks/${trackId}/requests`),
  decideEnrollment: (enrollmentId, action) =>
    http.patch(`/instructor/enrollments/${enrollmentId}`, { action }),
  members: (trackId) => http.get(`/instructor/tracks/${trackId}/members`),
  removeMember: (trackId, studentId) =>
    http.delete(`/instructor/tracks/${trackId}/members/${studentId}`),
  createAnnouncement: (trackId, payload) => {
    if (payload instanceof FormData) {
      return http.post(`/instructor/tracks/${trackId}/announcements`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
    return http.post(`/instructor/tracks/${trackId}/announcements`, payload);
  },
  announcements: (trackId) => http.get(`/tracks/${trackId}/announcements`),
  createTask: (trackId, payload) => {
    if (payload instanceof FormData) {
      return http.post(`/instructor/tracks/${trackId}/tasks`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
    return http.post(`/instructor/tracks/${trackId}/tasks`, payload);
  },
  tasks: (trackId) => http.get(`/tracks/${trackId}/tasks`),
  taskDetails: (taskId) => http.get(`/tasks/${taskId}`),
  trackLeaderboard: (trackId) => http.get(`/tracks/${trackId}/leaderboard`),
  globalLeaderboard: (params = {}) => http.get("/leaderboard/global", { params }),
};

export const submissionsApi = {
  submitTask: (taskId, formData) =>
    http.post(`/tasks/${taskId}/submissions`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  mySubmission: (taskId) => http.get(`/tasks/${taskId}/submission/me`),
  instructorTaskSubmissions: (taskId) => http.get(`/instructor/tasks/${taskId}/submissions`),
  gradeSubmission: (submissionId, payload) =>
    http.patch(`/instructor/submissions/${submissionId}/grade`, payload),
  bonusSubmission: (submissionId, payload) =>
    http.post(`/instructor/submissions/${submissionId}/bonus`, payload),
};

export const profileApi = {
  me: () => http.get("/profile/me"),
  studentProfileForInstructor: (trackId, studentId) =>
    http.get(`/instructor/tracks/${trackId}/students/${studentId}/profile`),
};

export const feedbackApi = {
  create: (payload) => {
    if (payload instanceof FormData) {
      return http.post("/feedback", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
    return http.post("/feedback", payload);
  },
  list: () => http.get("/instructor/feedback"),
};

export const analyticsApi = {
  instructorTrack: (trackId) => http.get(`/analytics/instructor/${trackId}`),
  adminGlobal: () => http.get("/analytics/admin/global"),
};

export const adminApi = {
  createTrack: (payload) => {
    if (payload instanceof FormData) {
      return http.post("/admin/tracks", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
    return http.post("/admin/tracks", payload);
  },
  updateTrack: (trackId, payload) => {
    if (payload instanceof FormData) {
      return http.put(`/admin/tracks/${trackId}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
    return http.put(`/admin/tracks/${trackId}`, payload);
  },
  deleteTrack: (trackId) => http.delete(`/admin/tracks/${trackId}`),
  assignInstructor: (trackId, payload) => {
    const body = typeof payload === "string" ? { instructorId: payload } : payload;
    return http.patch(`/admin/tracks/${trackId}/assign-instructor`, body);
  },
  listInstructors: () => http.get("/admin/instructors"),
  updateUserStatus: (userId, status) =>
    http.patch(`/admin/users/${userId}/status`, { status }),
  auditLogs: () => http.get("/admin/audit-logs"),
};
